<template>
    <gz-auth-view-template :bc="false">
        <GZ-PageTitle title="Юридические лица" slot="title"/>

        <GZ-StaticNotification slot="notification"/>
        
        <section slot="above-content" class="gz-tabs gz-tabs__section">
            <router-link 
                to="/admin/service-entity/list" 
                class="gz-tabs__item"
            >Список юридических лиц</router-link>
        </section>

        <section slot="content">
            <router-view></router-view>
        </section>        
    </gz-auth-view-template>
</template>

<script>
export default {
    name: 'AdminServiceEntityView'
}
</script>